export default (value) => {
  if(!value)
    return  '';

  return JSON.stringify(value);
};
